import { CircularProgress, Typography } from '@material-ui/core';
import { modalClose } from 'modules/modal/actions';
import { getRecoveriesCountFromRequestUuidRequest } from 'modules/users/actions';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import i18n from 'i18n';

interface RecoverUserByRequestUuidModalContentProps {
  requestUuid: string;
  isLoadingRecoveriesCountFromRequestUuid: boolean;
  recoveriesCountFromRequestUuid: number;
  getRecoveriesCountFromRequestUuidRequest: ({ requestUuid }) => void;
}
const RecoverUserByRequestUuidModalContent = ({
  requestUuid,
  isLoadingRecoveriesCountFromRequestUuid,
  recoveriesCountFromRequestUuid,
  getRecoveriesCountFromRequestUuidRequest,
}: RecoverUserByRequestUuidModalContentProps) => {
  React.useEffect(() => {
    getRecoveriesCountFromRequestUuidRequest({ requestUuid });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestUuid]);

  return isLoadingRecoveriesCountFromRequestUuid ? (
    <CircularProgress size={15} />
  ) : (
    <Typography style={{ fontSize: 12 }}>
      {i18n.t('USERS_PAGE.RECOVER_USER_BY_REQUEST_MODAL_CONTENT_KEY', {
        requestUuid,
        count: recoveriesCountFromRequestUuid,
      })}
    </Typography>
  );
};

const mapStateToProps = ({
  users: {
    recoveriesCountFromRequestUuid,
    isLoadingRecoveriesCountFromRequestUuid,
  },
}: ApplicationState) => ({
  recoveriesCountFromRequestUuid,
  isLoadingRecoveriesCountFromRequestUuid,
});

export default connect(mapStateToProps, {
  getRecoveriesCountFromRequestUuidRequest,
  modalClose,
})(RecoverUserByRequestUuidModalContent);
